import { render, staticRenderFns } from "./goldsilverSaleProfit.vue?vue&type=template&id=fbf114aa&scoped=true&"
import script from "./goldsilverSaleProfit.vue?vue&type=script&lang=js&"
export * from "./goldsilverSaleProfit.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverSaleProfit.vue?vue&type=style&index=0&id=fbf114aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf114aa",
  null
  
)

export default component.exports